const LOADER_ON = "@spinner/loaderOn";
const LOADER_OFF = "@spinner/loaderOff";

export default {
  LOADER_ON,
  LOADER_OFF,
};
